import PublicLayout from "@/components/public/PublicLayout";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import {
  ReceiptText, FileText, Package, CreditCard, BarChart3, Users,
  Wallet, Calculator, Building2, Sparkles, Shield, Smartphone
} from "lucide-react";

const FEATURES = [
  { icon: ReceiptText, title: "GST Invoices", desc: "Tax invoices with CGST/SGST/IGST, HSN codes, UPI QR, digital signature." },
  { icon: FileText, title: "Quotations", desc: "Send professional quotations. Convert to invoices in one click." },
  { icon: Package, title: "Inventory", desc: "Track stock, warehouses, low-stock alerts, batch numbers." },
  { icon: CreditCard, title: "Payments", desc: "Cash, UPI, Cheque, Card, Bank. Auto-reconciled with invoices." },
  { icon: Wallet, title: "Expenses", desc: "Categorise expenses with vendor bills, recurring expense support." },
  { icon: BarChart3, title: "Reports", desc: "Sales, P&L, GST, Inventory, Party Ledger — export PDF/Excel." },
  { icon: Users, title: "Customer Ledger", desc: "Complete history of sales, payments and outstanding by party." },
  { icon: Calculator, title: "GST Ready", desc: "HSN summary, GSTR-1/3B ready, built-in GST calculator." },
  { icon: Building2, title: "Multi-business", desc: "Manage multiple companies from a single account." },
  { icon: Sparkles, title: "AI Assistant", desc: "Ask questions about your data, get sales forecasts instantly." },
  { icon: Shield, title: "Secure by default", desc: "Encrypted storage, role-based permissions, audit logs." },
  { icon: Smartphone, title: "Works everywhere", desc: "Responsive design — desktop, tablet, Android and iPhone." },
];

export default function Features() {
  return (
    <PublicLayout>
      <section className="max-w-[1400px] mx-auto px-4 sm:px-6 py-16">
        <div className="text-center max-w-2xl mx-auto">
          <h1 className="font-heading text-4xl sm:text-5xl font-bold tracking-tight">Every feature your business needs</h1>
          <p className="mt-4 text-muted-foreground">A complete toolkit for GST billing, inventory, payments, and reports — no add-ons required.</p>
        </div>
        <div className="mt-12 grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {FEATURES.map((f) => (
            <Card key={f.title} className="p-6" data-testid={`features-page-${f.title.toLowerCase().replace(/\s+/g, "-")}`}>
              <div className="w-10 h-10 rounded-lg bg-primary/10 text-primary grid place-items-center mb-3">
                <f.icon size={18} />
              </div>
              <div className="font-heading font-semibold">{f.title}</div>
              <div className="text-sm text-muted-foreground mt-1">{f.desc}</div>
            </Card>
          ))}
        </div>
        <div className="mt-16 text-center">
          <Button asChild size="lg"><Link to="/signup">Try all features free for 14 days</Link></Button>
        </div>
      </section>
    </PublicLayout>
  );
}
